<template>
  <simple-dialog
      :value="visible"
      title-text="事業者情報"
      apply-text=""
      @close="closeOwnerDialog">
    <owner-form
        :owner="ownerInfo"
        readonly>
    </owner-form>

    <v-card outlined class="elevation-0 mt-3" v-if="isOurself || ownerInfo.detailViewable">
      <v-card-title style="font-size: 110%;">サイト</v-card-title>
      <v-card-text>
        <el-table :data="terminals" border>
          <el-table-column
              label="ID"
              prop="id"
              width="120">
          </el-table-column>
          <el-table-column
              label="サイト名"
              prop="name"
              width="200">
            <template #default="{row}">
              {{ row.name }}
              <template v-if="row.belongs">
                <el-tooltip content="現在表示しているサイトです" placement="right" :open-delay="500">
                  <v-icon small>mdi-account-box</v-icon>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>
          <el-table-column
              label="説明"
              prop="description">
            <template #default="{row}">
              <table-inline>
                <text-field-like
                    :value="row.description"
                    placeholder="未設定"
                    multi-line>
                </text-field-like>
              </table-inline>
            </template>
          </el-table-column>
          <template  v-if="isOurself">
            <el-table-column
                prop="pollingRate"
                label="ポーリング周期(秒)"
                width="100">
            </el-table-column>
            <el-table-column
                prop="createdAt"
                label="登録日"
                width="100">
              <template #default="{row}">
                {{ formatDate(row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column
                prop="publishing"
                label="公開"
                width="50"
                align="center">
              <template #default="{row}">
                <readonly-checkbox :value="row.publishing"></readonly-checkbox>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </v-card-text>
    </v-card>
  </simple-dialog>
</template>

<script>
import OwnerForm from "@/components/pages/admin/OwnerShow/OwnerForm.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import {mapGetters} from "vuex";
import Formatter from "@/utils/Formatter";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
export default {
  name: "OwnerInfoDialog",
  components: {TableInline, TextFieldLike, ReadonlyCheckbox, SimpleDialog, OwnerForm},
  mixins: [
    Formatter
  ],
  props: {
    ownerId: {
      type: [String, Boolean],
      default: false
    }
  },
  model: {
    prop: 'ownerId',
    event: 'change'
  },
  data() {
    return {
      visible: false,
      ownerInfo: {},
      terminals: [],
      isOurself: false,
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
  },
  methods: {
    async openOwnerDialog(ownerId) {
      if(ownerId === this.account?.owner.id || ownerId === 'self') {
        this.visible = true;
        this.isOurself = true;
        this.ownerInfo = this.account.owner;
        this.terminals = await this.loadTerminals();
        return;
      }

      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
      });
      try {
        const {data: ownerInfo} = await this.hcsClient.get(`/assets/owners/${ownerId}`);
        this.visible = true;
        this.isOurself = false;
        this.ownerInfo = ownerInfo;
        this.terminals = await this.loadAssetsTerminals();
      } finally {
        loading.close();
      }
    },
    async closeOwnerDialog() {
      for(const [k, v] of Object.entries(this.$options.data.apply(this))) {
        this.$set(this, k, v);
      }
      this.$emit('change', false);
    },
    async loadTerminals() {
      const {data: terminals} = await this.hcsClient.get('/terminals');
      return terminals.map(t => {
        return {
          ...t,
          belongs: this.account?.user?.terminalId === t.id
        };
      });
    },
    async loadAssetsTerminals() {
      const {data: terminals} = await this.hcsClient.get('/assets/customer_terminals', {
        params: {'q[owner_id_eq]': this.ownerId}
      });
      return terminals.filter(t => t.ownerId === this.ownerId);
    }
  },
  watch: {
    ownerId(ownerId) {
      if(ownerId) {
        this.openOwnerDialog(ownerId);
      } else {
        this.closeOwnerDialog();
      }
    }
  }
}
</script>

<style scoped>

</style>
